export const aggregateDealNotifications = dealsArray => {
  const PRICE_CHANGE = 'priceChangeFlag';
  const VEHICLE_CHANGE = 'sellingVehicleChangeFlag';
  const DEAL_TYPE_CHANGE = 'dealTypeChangeFlag';
  const PAYMENT_CHANGE = 'paymentChangeFlag';
  const CREDIT_APP_CHANGE = 'creditAppStatusChangeFlag';
  const notifications = {};
  let totalCount = 0;
  dealsArray.forEach(_ref => {
    let {
      deal,
      vehicle,
      creditApp
    } = _ref;
    if (vehicle?.[PRICE_CHANGE]) {
      notifications[PRICE_CHANGE] = (notifications[PRICE_CHANGE] || 0) + 1;
      totalCount += 1;
    }
    if (vehicle?.[VEHICLE_CHANGE]) {
      notifications[VEHICLE_CHANGE] = (notifications[VEHICLE_CHANGE] || 0) + 1;
      totalCount += 1;
    }
    if (deal?.[DEAL_TYPE_CHANGE]) {
      notifications[DEAL_TYPE_CHANGE] = (notifications[DEAL_TYPE_CHANGE] || 0) + 1;
      totalCount += 1;
    }
    if (deal?.[PAYMENT_CHANGE]) {
      notifications[PAYMENT_CHANGE] = (notifications[PAYMENT_CHANGE] || 0) + 1;
      totalCount += 1;
    }
    if (creditApp?.isDecisionChanged) {
      notifications[CREDIT_APP_CHANGE] = (notifications[CREDIT_APP_CHANGE] || 0) + 1;
      totalCount += 1;
    }
  });
  if (totalCount) {
    notifications.total = totalCount;
  }
  return notifications;
};
export default aggregateDealNotifications;